import { useQuery, gql } from '@apollo/client';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

const GET_CURRENT_EVENTS = gql`
  query Events($filter: EventFilter) {
    events(filter: $filter) {
      edges {
        node {
          experienceId
        }
      }
    }
  }
`;

export function useGetExperiencesHappeningNowIds() {
  // Calculate once on mount
  const now = useMemo(() => DateTime.utc().toISO(), []);
  const { data, loading, error } = useQuery(GET_CURRENT_EVENTS, {
    variables: {
      filter: {
        start: { lte: now },
        end: { gte: now },
      },
    },
    fetchPolicy: 'cache-first', // avoid unnecessary network requests
    // Optionally, remove or adjust pollInterval if not needed
    // pollInterval: 60000,
  });
  const ids: string[] = useMemo(() => {
    if (!data) return [];
    return Array.from(
      new Set(
        data.events.edges
          .map((e: any) => e?.node?.experienceId)
          .filter((id: string | null | undefined) => id != null),
      ),
    );
  }, [data]);
  return { ids, loading, error };
}
